import { ONBOARDING_SYNC_COPY } from '@sonar-software/sonar-ts-constants';
import React from 'react';

import { OnboardingStep, OnboardingSteps, SyncView, TeamInvites } from './general';

export const SyncFirstTimeView: React.FC = () =>
	<SyncView
		pre={ <OnboardingSteps currentStep={ OnboardingStep.Team } /> }
		title={ ONBOARDING_SYNC_COPY.READY_SHORTLY }>
		<p>{ ONBOARDING_SYNC_COPY.MAIN_DIALOG }</p>
		<p>{ ONBOARDING_SYNC_COPY.ADD_TEAM_INFO }</p>
		<TeamInvites />
	</SyncView>;
